import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import  CallReport  from "../components/reports/CallReport";

export const CallReportPage = () => {
  return (
    <MasterLayout>
      <CallReport />
    </MasterLayout>
  );
};
